import { render } from "./user-info.vue?vue&type=template&id=630d78c0&scoped=true"
import script from "./user-info.vue?vue&type=script&lang=js"
export * from "./user-info.vue?vue&type=script&lang=js"

import "./user-info.vue?vue&type=style&index=0&id=630d78c0&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630d78c0"]])

export default __exports__